import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { IUserPasswordUpdateParams } from 'src/app/shared/interfaces/user/user.interface';
import { AlertService } from 'src/app/shared/services/alert.service';
import { PasswordService } from 'src/app/shared/services/password/password.service';
import { UsersService } from 'src/app/shared/services/users/users.service';
import {
  asyncPasswordValidator,
  passwordConfirmationValidator,
} from 'src/app/shared/validators/validators';

@Component({
  selector: 'app-change-user-password-modal',
  templateUrl: './change-user-password-modal.component.html',
})
export class ChangeUserPasswordModalComponent implements OnInit, OnDestroy {
  @Input() userId: number;

  isLoading: boolean;
  form: UntypedFormGroup;

  passwordText: string;

  subscriptions: Subscription = new Subscription();

  constructor(
    private userService: UsersService,
    public activeModal: NgbActiveModal,
    private alertService: AlertService,
    private fb: UntypedFormBuilder,
    private passwordService: PasswordService,
  ) {}

  ngOnInit() {
    this.form = this.fb.group(
      {
        oldPassword: [null, [Validators.required]],
        password: [
          null,
          Validators.required,
          asyncPasswordValidator(this.passwordService),
        ],
        confirmPassword: [
          null,
          Validators.required,
          asyncPasswordValidator(this.passwordService),
        ],
      },
      {
        validators: passwordConfirmationValidator(
          'password',
          'confirmPassword',
        ),
      },
    );
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  close() {
    this.activeModal.dismiss();
  }

  onSubmit() {
    this.isLoading = true;

    const passwordForm: IUserPasswordUpdateParams = {
      userId: this.userId,
      ...this.form.value,
    };

    this.subscriptions.add(
      this.userService.updatePassword(passwordForm).subscribe({
        next: () => {
          this.isLoading = false;
          this.activeModal.close();
          this.alertService.success('Password changed successfully');
        },
        error: (error) => {
          this.isLoading = false;
          this.alertService.error(error as string);
        },
      }),
    );
  }
}
